bq.regionUpdater = function(element, options) {
  this.options   = options;
  this.$element  = $(element);
};

bq.regionUpdater.prototype = {
  init : function(){
    this.options.bqRegionData = JSON.parse(decodeURIComponent(this.options.bqRegionData));
    this.options.countriesWithRequiredStates = JSON.parse(decodeURIComponent(this.options.countriesWithRequiredStates));
    this.options.config = this.options.bqRegionData.config;
    this.options.bqRegionInput = $(this.options.bqRegionInput);
    this.options.bqRegionSelect = $(this.options.bqRegionSelect);
    delete this.options.bqRegionData.config;

    this.$element.on('change', this.update.bind(this) );
    this.update();
  },
  update : function(){
    var key = this.$element.val();
    if(key in this.options.bqRegionData){
      this.updateSelect(key);
      this.showSelect();
    } else {
      this.updateSelect();
      this.hideSelect();
    }
  },
  showSelect : function(){
    this.options.bqRegionInput.hide();
    this.options.bqRegionSelect.show();
    if (this.options.countriesWithRequiredStates.indexOf(this.$element.val()) !== -1) {
      this.options.bqRegionSelect.attr('required','');
      this.options.bqRegionSelect.attr('data-validate-required','true');
    } else {
      this.options.bqRegionSelect.removeAttr('required');
      this.options.bqRegionSelect.removeAttr('data-validate-required');
    }

    this.options.bqRegionSelect.addClass('validate-select');
  },
  hideSelect : function(){
    this.options.bqRegionInput.show();
    this.options.bqRegionSelect.hide();
    this.options.bqRegionSelect.removeAttr('required');
    this.options.bqRegionSelect.removeAttr('data-validate-required');
    this.options.bqRegionSelect.removeClass('validate-select');
  },
  updateSelect : function(key){
    this.options.bqRegionSelect.find('option').not(':first').remove();
    if(!key) return;
    var html = '';
    var thiz = this;
    $.each(this.options.bqRegionData[key], function(id, elem){
      var name = elem.name.replace(/\+/g,' ');
      var selected = '';
      if (thiz.options.bqSelectedRegionId && thiz.options.bqSelectedRegionId == id) {
        selected = 'selected="selected"';
      }
      html += '<option value="' + id + '" title="'+ name +'" ' + selected + '>'+ name +'</option>';
    });
    this.options.bqRegionSelect.append(html);
  }
};


var bqRegionUpdaterold = $.fn.bqRegionUpdater;

$.fn.bqRegionUpdater = function (option) {
  return this.each(function () {
    var $this   = $(this);
    var data    = $this.data('bq.regionUpdater');
    var options = $.extend({}, $this.data(), typeof(option) === 'object' && option);

    if (!data) { $this.data('bq.regionUpdater', (data = new bq.regionUpdater(this, options))); }
    data.init();
  });
};

$.fn.bqRegionUpdater.Constructor = bq.bqRegionUpdater;



$.fn.bqRegionUpdater.noConflict = function () {
  $.fn.bqRegionUpdater = bqRegionUpdaterold;
  return this;
};



bq.bqRegionUpdaterInit = function() {
  $('[data-bq="region-updater"]').each(function () {
    var el = $(this);
    if(el.data('bq.regionUpdater')) { return; }
    el.bqRegionUpdater(el.data());
  });
};

bq.init.push(bq.bqRegionUpdaterInit);
